"use client"

import { useUiControlLabels } from "./ui-control-labels-context"

/** Localize app-owned error summaries while retaining raw errors in query state. */
export function UiErrorText({ message, fallback }: { message?: string | null; fallback?: string }) {
  const { error } = useUiControlLabels()
  const text = message ? error(message) : fallback
  if (!text) return null
  return <span key={text}>{text}</span>
}
